import { CityIcon } from '@/shared/ui/icons/CityIcon'
import { InfoIcon } from '@/shared/ui/icons/InfoIcon'
import { Chip } from '@/shared/ui/Chip'
import { profileTone } from '@/shared/lib/profileTone'
import type { SolutionCard } from '@/shared/lib/apiTypes'

function DividedList({ items }: { items: string[] }) {
  return (
    <span className="ui-meta">
      {items.map((text, i) => (
        <span key={text} className="list-card__meta-item">
          {i > 0 && <span className="ui-divider-v" aria-hidden="true" />}
          <span>{text}</span>
        </span>
      ))}
    </span>
  )
}

function DottedList({ items, size = 'sm' }: { items: string[]; size?: 'sm' | 'lg' }) {
  return (
    <span className={size === 'lg' ? 'list-card__meta list-card__meta--lg' : 'list-card__meta'}>
      {items.map((text, i) => (
        <span key={text} className="list-card__meta-item">
          {i > 0 && <span className="ui-dot" aria-hidden="true" />}
          <span>{text}</span>
        </span>
      ))}
    </span>
  )
}

export function SolutionCardBody({
  card,
  dongLabel,
  certLabel,
  actionText,
}: {
  card: SolutionCard
  dongLabel: (code: string) => string
  certLabel?: string | undefined
  actionText?: string
}) {
  return (
    <>
      <div className="list-card__header">
        <div className="list-card__tags">
          <span className="list-card__profile" aria-hidden="true" style={{ background: profileTone(card.org.id) }}>
            <CityIcon size={20} />
          </span>
          <DividedList
            items={certLabel === undefined ? [card.org.name] : [card.org.name, certLabel]}
          />
        </div>
        <div className="list-card__title-group">
          <p className="list-card__title">{card.title}</p>
          <p className="list-card__sub">{card.problemSolved}</p>
          {card.accessCondition !== null && card.accessCondition.length > 0 && (
            <span className="list-card__notice">
              <InfoIcon />
              <span>{card.accessCondition}</span>
            </span>
          )}
        </div>
      </div>
      <div className="list-card__footer">
        <DottedList items={(card.serviceDongCodes ?? []).map(dongLabel)} />
        {actionText !== undefined && (
          <Chip tone="soft" className="list-card__action">{actionText}</Chip>
        )}
      </div>
    </>
  )
}
